import { SvgIcon } from '@material-ui/core';
import { ReactComponent as more } from './more.svg';

export default function MoreIcon(props) {
  return <SvgIcon {...props} component={more} viewBox="0 0 24 25" />;
}
